import toast from 'react-hot-toast'
import { Icon } from '@iconify/react'

// DECLARE COLOR
const SECONDARY_GRAY = '#909090'
const ERROR_RED = '#ad0707'
const SUCCESS_GREEN = '#19cb76'
const LOADING_BLUE = '#155cab'
const WHITE_TEXT = '#fff'

// DECLARE STATE
const CREDENTIAL_TOAST = 'creditialError'
const ERROR_TOAST = 'error'
const DELETE_TOAST = 'delete'
const SUCCESS_TOAST = 'success'
const LOADING_TOAST = 'loading'

// Default loading ID if none provided
const DEFAULT_TOAST_ID = 'default-toast-id'

// Custom keys for developer use
export const toastKey = {
  ERROR_REPORTS: {
    GET: 'error-report',
    DETAIL: 'error-report.detail',
  },
  SYSTEM: {
    ADMINS: {
      GET: 'admin_permission',
      DETAIL: 'admin_permission.detail',
      ADD: 'admin_add',
      DELETE: 'admin_delete',
    },
  },
  BOOKS_MANAGEMENT: {
    LIST: {
      GET: 'book_list',
      DETAIL: 'book_list.detail',
      DEACTIVE: 'book_list.deactive',
    },
    PACKAGE: {
      LIST: {
        GET: 'book_package',
        DETAIL: 'book_package.detail',
        // GETLIST:'book_package_list'
      },
      PACKAGEANDBOOKS: {
        DELETE: 'delete_book_from_book_package',
      },
    },
    BORROW: {
      LIST: {
        GET: 'book_borrow',
        DETAIL: 'book_borrow.detail',
        EXPORT: 'book_borrow_export',
      },
      AccountPerBook: {
        GET: 'book_borrow_account',
      },
    },
  },
  ACCOUNT: {
    GET: 'account_list',
    DETAIL: 'account_list.detail',
    GUEST: {
      GET: 'guest_list',
      DETAIL: 'guest_list.detail',
      EXPORT: 'guest_export',
      CREATE: 'guest_create',
      DELETE: 'guest_delete',
    },
    GROUP: {
      LIST: 'account_group',
      EXPORT: 'account_export',
      ADD: 'account_add_group',
      REMOVE: 'account_remove_group',
    },
  },
}

// SET UP BACKGROUND COLOR
const toastStyles = {
  success: {
    background: SUCCESS_GREEN,
  },
  error: {
    background: ERROR_RED,
  },
  creditialError: {
    background: ERROR_RED,
  },
  loading: {
    background: LOADING_BLUE,
  },
  delete: {
    background: SECONDARY_GRAY,
  },
}

const iconConfig = {
  class: 'text-2xl mr-3',
}

const toastStyle = {
  display: 'flex',
  alignItems: 'center',
  width: '310px',
}

const toastStylesCommon = {
  color: WHITE_TEXT,
  borderRadius: '8px',
  fontSize: '18px',
  maxWidth: '480px',
  wordWrap: 'break-word',
}

// SET UP ICONS
const icons = {
  success: <Icon icon="ph:check-circle-fill" className={iconConfig.class} />,
  error: <Icon icon="ph:warning-bold" className={iconConfig.class} />,
  loading: (
    <Icon icon="ph:arrows-clockwise-bold" className={iconConfig.class} />
  ),
  // delete: <Icon icon="ph:trash-bold" className={iconConfig.class} />,
  delete: <Icon icon="ph:check-circle-fill" className={iconConfig.class} />,
  creditialError: (
    <Icon icon="ph:shield-warning-bold" className={iconConfig.class} />
  ),
}

// TOAST FOR LOADING FUNCTION
const showLoadingToastOnly = (message, toastId = DEFAULT_TOAST_ID) => {
  toast.loading(
    <div style={toastStyle}>
      {icons[LOADING_TOAST]}
      <div className="flex-1 text-white">{message}</div>
    </div>,
    {
      id: toastId,
      style: {
        ...toastStyles[LOADING_TOAST],
        ...toastStylesCommon,
      },
      icon: null,
    }
  )
}

// TOAST FOR OTHER TYPES
const showToast = ({
  type,
  message,
  error = '',
  toastId = DEFAULT_TOAST_ID,
}) => {
  const config = {
    id: toastId,
    style: {
      ...toastStyles[type],
      ...toastStylesCommon,
    },
  }

  const content = (
    <div style={toastStyle}>
      {icons[type]}
      <div className="flex flex-1 flex-col items-start gap-2 text-white">
        <div>{message}</div>
        {error.length > 0 && <div>Lỗi: {error}</div>}
      </div>
    </div>
  )

  // switch (type) {
  //   case SUCCESS_TOAST:
  //     toast.success(content, config)
  //     break
  //   case ERROR_TOAST:
  //     toast.error(content, config)
  //     break
  //   case DELETE_TOAST:
  //   case CREDENTIAL_TOAST:
  //     toast(content, config)
  //     break
  //   default:
  //     toast(content, config)
  toast(content, config)
}

// EXPORT ALL FUNCTIONS
export const showSuccessToast = (message, toastId = DEFAULT_TOAST_ID) =>
  showToast({ type: SUCCESS_TOAST, message, toastId })

export const showErrorToast = ({
  message,
  error,
  toastId = DEFAULT_TOAST_ID,
}) => showToast({ type: ERROR_TOAST, message, error, toastId })

export const showCredentialToast = (message, toastId = DEFAULT_TOAST_ID) =>
  showToast({ type: CREDENTIAL_TOAST, message, toastId })

export const showDeleteToast = (message, toastId = DEFAULT_TOAST_ID) =>
  showToast({ type: DELETE_TOAST, message, toastId })

export const showLoadingToast = showLoadingToastOnly
